module.exports = __webpack_public_path__ + "media/customizations/paintedprairie/back-f8595f30905535af408c2554c444b825.jpg";